<template>
  <div>
    <div
      v-for="item in checkboxItems"
      :key="item.description"
      class="checkbox-repeater"
    >
      <input
        :id="item.description"
        type="checkbox"
        :checked="item.checkboxValue"
        @change="changeFunction"
      >
      <label>{{ item.description }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OwalCheckboxPanel',
  props: ['changeFunction', 'checkboxItems'],
  data: function () {
    return {
      item: undefined,
      timeFormat: 'hh:mm:ss',
      dateFormat: 'YYYY-MM-DD',
    }
  },
}
</script>

<style scoped>
  .owal.input {
    background: #F0F0F0;
    color: #475669;
    border: 1px solid #E0E0E0;
    border-radius: 5px;
    display: flex;
    font-family: 'Avenir-Medium';
    font-weight: bold;
    margin: 0 0.25rem;
    letter-spacing: 0;
    padding: 0.5rem 1rem;
    text-align: center;
    z-index: 1;
    transition: opacity 200ms ease, transform 200ms ease;
  }

  .owal.input.basic {
    width: 9rem;
  }

  .owal.input.native {
    justify-content: center;
    display: flex;
    overflow: visible;
    transition: width 200ms ease;
    box-sizing: border-box;
    cursor: pointer;
  }

  .owal.input.native {
    width: 13.5rem;
  }

  .owal.input.native:hover {
    width: 14rem;
    transform: scale(1.05);
    opacity: 0.8;
  }
</style>
